import { TableRow } from "@material-ui/core";
import React from "react";
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Paper from '@material-ui/core/Paper';

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const data = this.props.data;
        const dayCount = this.props.daysCount;
        const total = this.props.total;
        const allTotal = this.props.allTotal;

        return (
            <div>
                <h3><center><u>Tea Worker Deployment Details Report</u></center></h3>
                <div className="row pl-2 pb-2 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Estate: </b> {searchData.estate}</div>
                </div>
                <div className="row pl-2 pb-2 pt-2">
                    {searchData.division = 'undefined' ?
                        <div className="col"><b>Division: </b>All</div>
                        :
                        <div className="col"><b>Division: </b>{searchData.division} </div>
                    }
                    <div className="col"><b>From: </b> {searchData.month}</div>
                </div>
                <div>
                    <TableContainer component={Paper}>

                        <>
                            <Table aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Task Name</TableCell>
                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Task Description</TableCell>
                                        {dayCount.map((count, i) => (
                                            <TableCell key={i} align="center" style={{ fontWeight: "bold" }}>{count}</TableCell>
                                        ))}
                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Total</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data.map((rows, i) => (
                                        <TableRow key={i} >
                                            <TableCell component="th" scope="row" align="center"> {rows.taskName}</TableCell>
                                            <TableCell component="th" scope="row" align="center"> {rows.taskDescription}</TableCell>
                                            {dayCount.map((count) => {
                                                const result = rows[count]
                                                return (
                                                    <TableCell component="th" scope="row" align="center"> {result == undefined ? '-' : result}</TableCell>
                                                );

                                            })}
                                            <TableCell component="th" scope="row" align="center"> {rows.total}</TableCell>
                                        </TableRow>
                                    ))}
                                    <TableRow>
                                        <TableCell component="th" scope="row" align="center" colSpan={2} style={{ fontWeight: "bold" }}> Total</TableCell>
                                        {dayCount.map((column) => {
                                            const value = allTotal.find(x => x.name == column)
                                            return (
                                                <TableCell style={{ fontWeight: "bold" }} align='center'>{value == undefined ? '-' :
                                                    parseInt(value.value)}</TableCell>
                                            );
                                        })}
                                        <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold" }}> {parseInt(total)}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </>

                    </TableContainer>
                </div>

            </div>
        );
    }
}